/** Redesign v3 board copy for the Arabic /bousala landing. The question bank is NOT here. */

/** One-line axis descriptions, in SECTIONS order (the bank only has long intros). */
export const AXIS_LINES_AR = [
  "لغوي، منطقي، بصري، حركي، اجتماعي… وين بيلمع عقلك فعلاً.",
  "شو نوع الشغل اللي بيجذبك، مش اللي بينحفظ أحسن.",
  "الطبيعة من جوّا، وأي بيئة دراسة وشغل بتريّح.",
  "وين الوضع هلق فعلاً، لنعرف شو منقوّي.",
  "شو بيحرّكك: الاستقرار، الحرية، الأثر، التحدي…",
  "كيف بيوصل الفهم أسرع: بالقراءة، بالسمع، بالتجربة، بالنقاش.",

  "قديش القرار الواثق قريب، وشو اللي ناقص.",
  "أسئلة سريعة وممتعة بتلمس البديهة، بلا ضغط.",
] as const;

export const TRUST_INTRO_AR =
  "أي اختبار نتيجته بتساوي قد ما الإجابات صادقة. عشان هيك البوصلة بتتأكد من ثلاث شغلات بكل محاولة:";

export const TRUST_ROWS_AR = [
  { n: "01", title: "انتباه", body: "أسئلة بسيطة مبثوثة بتتأكد إن الأسئلة عم تنقرا، مش عم تنكبس عالسريع." },
  { n: "02", title: "صدق", body: "أسئلة بتفرّق بين الجواب الصادق والجواب اللي بيجمّل الصورة." },
  { n: "03", title: "ثبات", body: "أسئلة بتقيس نفس الشي بطريقتين، لتتأكد إن الجواب ثابت ومش عشوائي." },
] as const;

export const STEPS_AR = [
  { n: "01", title: "تخصيص 45–60 دقيقة", body: "بمكان هادي، وبذهن صافي." },
  { n: "02", title: "الجواب عن الحال الحقيقي", body: "عن اليوم — مش عن الصورة الحلوة." },
  { n: "03", title: "بدون تسرّع", body: "قراءة الموقف، تخيّله، واختيار الأقرب للطبيعة." },
  { n: "04", title: "قراءة التقرير", body: "بيطلع مباشرة بالآخر. التوقّف والمتابعة بعدين كمان ممكن." },
] as const;

/** The six rows of the free report (live landing list). */
export const REPORT_ROWS_AR = [
  "أنواع ذكائك الأقوى، وكيف بتنفع بالدراسة والشغل.",
  "ميولك المهنية مرتّبة: أي عائلة مهن بتشدّك.",
  "ملامح شخصيتك، وأي بيئة دراسة وعمل بتناسبك.",
  "قيمك ودوافعك الأساسية — اللي لازم يتوفّر بأي مسار.",
  "طريقة تعلّمك المثلى، للدراسة بذكاء مش بجهد أكتر.",
  "قائمة تخصصات ومسارات مقترحة بتشبهك، مع مؤشر الجاهزية للقرار.",
] as const;

export const SAMPLE_BARS_AR = [
  { label: "منطقي رياضي", value: 72 },
  { label: "لغوي", value: 48 },
  { label: "بصري مكاني", value: 36 },
] as const;

export const SMART_DESCRIPTION_AR =
  "مبنية على نتيجتك المجانية وتفضيلاتك: البلد، الوضع المادي، والتخصصات المطروحة. تقرير مفصّل بـ 8 أقسام، بيراجعه فريق د. سارة — بالعربي أو بالإنجليزي.";
/** Each pill maps to a real Smart report section (comparison, challenges, plan_30d). */
export const SMART_PILLS_AR = ["مقارنة بين التخصصات", "التحديات المتوقعة", "خطة 30 يوم"] as const;

export const BOUSALA_FAQS_AR = [
  { q: "كم بتاخد وقت؟", a: "حوالي 45 لـ 60 دقيقة. بجلسة وحدة، أو على كذا جلسة — التوقّف والمتابعة بأي وقت." },
  { q: "هل النتيجة بتحدّد مصيري؟", a: "لأ. البوصلة بتوسّع الرؤية وبتدلّ على الخيارات اللي بتشبهك — بس القرار بيضل إلك." },
  { q: "لازم أكون قرّرت تخصص قبل ما أبلّش؟", a: "أبداً. حتى مع الضياع الكامل، هي بالضبط اللحظة اللي البوصلة بتنفع فيها." },
  { q: "بأي عمر مناسبة؟", a: "للشباب من 15 لـ 35 سنة — بالمدرسة، بالجامعة، بعد التخرّج، أو بالشغل مع تفكير بإعادة توجيه المسار." },
  { q: "شو بيميّزها عن أي اختبار مجاني على الإنترنت؟", a: "مبنية على منهج علمي، بتقيس 8 محاور مع بعض (مش محور واحد)، وفيها آلية بتتحقق من صدق الإجابات — عشان النتيجة تعكسك فعلاً." },
] as const;

/** Shown after the base FAQs only while the Smart product is active. */
export const SMART_FAQS_AR = [
  { q: "شو الفرق بين البوصلة المجانية والذكية؟", a: "المجانية بتعطيك نتيجتك وتقرير عن ذكاءاتك وميولك والتخصصات الأقرب إلك. الذكية بتبني على نفس النتيجة وبتضيف تفضيلاتك (البلد، الوضع المادي، التخصصات يلي عم تفكر فيها)، وبتطلعلك تقرير مفصّل بـ8 أقسام فيه مقارنة وتحديات وخطة 30 يوم، يراجعه فريق د. سارة." },
  { q: "عملت البوصلة المجانية قبل، لازم أعيدها؟", a: "لأ، منعتمد نتيجتك الموجودة على حسابك." },
  { q: "كيف بدفع؟", a: "PayPal من برّا سوريا، شام كاش أو الهرم للحوالات من جوّا. بعد رفع صورة الإيصال منأكد الدفع خلال 24 ساعة، والبدء بالبوصلة مباشرة ممكن." },
  { q: "إيمتى بيوصلني التقرير؟", a: "خلال 24 ساعة من تعبئة نموذج التفضيلات." },
  { q: "مين بيكتب التقرير؟", a: "إجاباتك يقرأها فريق د. سارة وتُستخدم فقط لتحضير تقريرك. تُصاغ المسودة بمساعدة الذكاء الاصطناعي ويراجعها الفريق ويعدّلها قبل إرسالها لك، ولا يصل اسمك ولا بيانات تواصلك إلى الذكاء الاصطناعي أبداً." },
  { q: "بأي لغة بيوصلني التقرير؟", a: "بالعربي أو بالإنجليزي، حسب الاختيار بنموذج التفضيلات." },
] as const;

/** Picks the try-it questions from the bank: first likert and first scenario item of axis 1. */
export function pickTryItItems<T extends { type: string }>(items: readonly T[]): { likert: T | undefined; scenario: T | undefined } {
  return { likert: items.find((i) => i.type === "likert5"), scenario: items.find((i) => i.type === "scenario") };
}

/** Free-first description; the Smart clause is added only while Smart is active. */
export function bousalaDescription(smartActive: boolean): string {
  return smartActive
    ? "اختبار مجاني لعمر 15–35 من د. سارة النحّاس: 8 محاور، 45–60 دقيقة، وتقرير شخصي فوري يقترح التخصصات الجامعية الأقرب إلك. ومعه البوصلة الذكية بتقرير مفصّل بـ 10$."
    : "اختبار مجاني لعمر 15–35 من د. سارة النحّاس: 8 محاور، 45–60 دقيقة، وتقرير شخصي فوري يقترح التخصصات الجامعية الأقرب إلك.";
}
